import { faWifiSlash } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T } from "@repo/transifex";
import { useIsOnline } from "~/providers/store/auth";

export const NetworkStatus = () => {
  const isOnline = useIsOnline();

  if (isOnline) {
    return null;
  }

  return (
    <div className="flex items-center gap-2.5 text-warning-dark">
      <FontAwesomeIcon icon={faWifiSlash} />
      <p>
        <T _str="Connection lost" />
      </p>
    </div>
  );
};
